import api from "src/api/index";
import {STATE_MEDIA} from "src/config";

export async function getEventCategories () {
  try {
    const response =  await api.get(STATE_MEDIA + "api/dashboard/event-categories")
    return response.data?.items ?? []
  } catch (error) {
    console.error("ошибка загрузки категорий", error?.message)
  }
}